import React from "react";
import { ClockCounterClockwise } from "@phosphor-icons/react";
import { Card, Empty, aud } from "../ui";
import { fmtDate } from "../assess/parts";
import { ApprovalPill, EmailStatusPill } from "./parts";

function Row({ a, onOpen }) {
  return (
    <tr onClick={() => onOpen(a)} className="border-b border-neutral-900 hover:bg-white/[0.03] cursor-pointer align-top" data-testid={`wi-approval-history-row-${a.id}`}>
      <td className="py-2.5 pr-3 whitespace-nowrap"><div className="font-mono text-neutral-100">{a.otma || "—"}</div><div className="text-neutral-600">{a.chassis}</div></td>
      <td className="py-2.5 pr-3 text-neutral-300">{a.customer}<div className="text-neutral-600">{a.dealer}</div></td>
      <td className="py-2.5 pr-3 text-right tabular-nums text-[#73bf44]">{aud(a.amount, 2)}</td>
      <td className="py-2.5 pr-3 text-neutral-400">{a.approved_by?.name}<div className="text-neutral-600">{fmtDate(a.created_at)}</div></td>
      <td className="py-2.5 pr-3"><ApprovalPill status={a.status} />{a.status === "failed" && <div className="text-red-400/80 mt-1 max-w-[220px] truncate">{a.error}</div>}</td>
      <td className="py-2.5"><div className="flex flex-col gap-1 items-start">{a.emails.map((e) => <EmailStatusPill key={e.id} status={e.status} />)}</div></td>
    </tr>
  );
}

export function ApprovalHistory({ data, page, setPage, onOpen }) {
  return (
    <Card title={`Approved in the app${data ? ` · ${data.total}` : ""}`} icon={ClockCounterClockwise} testId="wi-approval-history">
      {!data ? <div className="h-24 animate-pulse" /> : !data.rows.length ? <Empty>Approvals you make here will be listed with their OTMA number and emails.</Empty> : (
        <>
          <div className="overflow-x-auto">
            <table className="w-full text-xs">
              <thead className="text-[0.6rem] uppercase tracking-wider text-neutral-500 text-left">
                <tr className="border-b border-neutral-800"><th className="py-2 pr-3">OTMA</th><th className="py-2 pr-3">Customer</th><th className="py-2 pr-3 text-right">Amount</th>
                  <th className="py-2 pr-3">Approved by</th><th className="py-2 pr-3">Monday.com</th><th className="py-2">Emails</th></tr>
              </thead>
              <tbody>{data.rows.map((a) => <Row key={a.id} a={a} onOpen={onOpen} />)}</tbody>
            </table>
          </div>
          {data.total > data.page_size && (
            <div className="flex items-center justify-end gap-3 pt-3 text-xs text-neutral-500">
              <button disabled={page === 0} onClick={() => setPage(page - 1)} className="hover:text-white disabled:opacity-30" data-testid="wi-approval-history-prev">Previous</button>
              <span>Page {page + 1} of {Math.ceil(data.total / data.page_size)}</span>
              <button disabled={(page + 1) * data.page_size >= data.total} onClick={() => setPage(page + 1)} className="hover:text-white disabled:opacity-30" data-testid="wi-approval-history-next">Next</button>
            </div>
          )}
        </>
      )}
    </Card>
  );
}
